import { useMemo } from 'react';
import { navbarDropdowns } from 'utils/constants'

const useItemIsDD = (val: string) => {

  const DDItem = useMemo(() => {
     return navbarDropdowns.includes(val);
  },[val])


  return DDItem;
}


export default useItemIsDD;



